module.exports = __webpack_public_path__ + "img/medal03.9f6cd87c.svg";